import React from "react"
import styled from "styled-components"
import useCityHome from "../../hooks/useCityHome"
import useTrattamentiHome from "../../hooks/useTrattamentiHome"
import useTrattamentiSearch from "../../hooks/useTrattamentiSearch"
import MobilePicker from "./MobilePicker"

const MobileSelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 50px;
`

const Select = styled.select`
  box-shadow: 5px 5px 20px #efefef;
  border: 1px solid #f7f7f7;
  font-size: 12px;
  padding-left: 10px;
  height: 40px;
  border-radius: 4px;
  -moz-appearance: none;
  -webkit-appearance: none;
  width: 200px;
`

const SelectTwo = styled(Select)`
  margin-top: 15px;
`

const Button = styled.div`
  display: flex;
  box-shadow: 5px 5px 20px #efefef;
  background: ${({ theme }) => theme.midblue};
  align-items: center;
  margin-top: 15px;
  color: white;
  font-weight: 500;
  justify-content: center;
  width: 200px;
  border-radius: 4px;
  height: 40px;
`

export default function MobileSelect({
  handleSubmit,
  setTrattamento,
  setCity,
}) {
  const trattamenti = useTrattamentiSearch()
  const cities = useCityHome()
  if (!trattamenti || !cities) {
    return null
  }
  return (
    <MobileSelectContainer>
      <Select
        onChange={event => setTrattamento(event.target.value)}
        on
        name="cars"
        id="cars"
      >
        <option value="">Trattamento</option>
        {trattamenti.map((t, i) => (
          <option key={i} value={t}>
            {t.trattamento}
          </option>
        ))}
      </Select>
      <SelectTwo
        onChange={event => setCity(event.target.value)}
        on
        name="cars"
        id="cars"
      >
        <option value="">Città</option>
        {cities.map((c, i) => (
          <option key={i + c} value={c}>
            {c.comune}
          </option>
        ))}
      </SelectTwo>
      <Button img={require("../../images/Search.png")} onClick={handleSubmit}>
        CERCA
      </Button>
    </MobileSelectContainer>
  )
}

export function MobileSelectCity({ handleSubmit, setCity }) {
  const cities = useCityHome()

  if (!cities) {
    return null
  }
  return (
    <MobileSelectContainer>
      <SelectTwo
        onChange={event => setCity(event.target.value)}
        on
        name="cars"
        id="cars"
      >
        <option value="">Città</option>
        {cities.map((c, i) => (
          <option key={i + c} value={c}>
            {c.comune}
          </option>
        ))}
      </SelectTwo>
      <Button img={require("../../images/Search.png")} onClick={handleSubmit}>
        CERCA
      </Button>
    </MobileSelectContainer>
  )
}
